export enum EmployeeRequestResponsibleForAnswersRequestableTypeEnum {
  ClockRegisterReviewRequest = 'App\\Models\\ClockRegisterReviewRequest',
  AbsenceRequest = 'App\\Models\\AbsenceRequest',
  RemoteWorkWeekdayExceptionRequest = 'App\\Models\\RemoteWorkWeekdayExceptionRequest',
  WorkingExtraHoursPeriod = 'App\\Models\\WorkingExtraHoursPeriod',
  DrivingRequest = 'App\\Models\\DrivingRequest',
  WorkingContractWeeklyScheduleExceptionRequest = 'App\\Models\\WorkingContractWeeklyScheduleExceptionRequest',
}
